export default __webpack_public_path__ + "static/media/slider-12.b5a396de.jpg";